import { memo } from 'react';
import { capitalize } from 'lodash';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Spacer' })((theme) => ({
  root: {
    height: 1,
    width: '100%',
    display: 'block',
  },
  marginXsmall: {
    margin: theme.spacing(1 / 2, 0),
  },
  marginSmall: {
    margin: theme.spacing(1, 0),
  },
  marginMedium: {
    margin: theme.spacing(1 + 1 / 2, 0),
  },
  marginLarge: {
    margin: theme.spacing(2, 0),
  },
}));

interface SpacerProps {
  readonly margin?: 'xsmall' | 'small' | 'medium' | 'large';
}

export const Spacer = memo<SpacerProps>(({ margin = 'medium' }) => {
  const { classes, cx } = useStyles();

  return <span className={cx(classes.root, classes[`margin${capitalize(margin)}`])} />;
});
